import { RelayPortalAccountsResponse } from './useRelayPortalAccounts.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchRelayPortalAccounts = async (memberId: number | string): Promise<RelayPortalAccountsResponse> => {
    const { data } = await collectiveApi.get<RelayPortalAccountsResponse>(`/relay-portal-accounts/${memberId}/`);
    return data;
};

export default fetchRelayPortalAccounts;
